/**
 * EGroupware API: switch jQuery to NOT use $ as early as possible
 *
 * @link http://www.egroupware.org
 * @license http://opensource.org/licenses/gpl-license.php GPL - GNU General Public License
 * @package api
 * @subpackage ajax
 * @author Ralf Becker <rb@egroupware.org>
 */
import "../../../vendor/bower-asset/jquery/dist/jquery.min.js";

jQuery.noConflict();